import React from 'react';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { updateBrokerConnectDataWithoutSave } from '../../../actions/brokerConnect/brokerConnectActionCreators';
import { connect } from 'react-redux';
import Days from './Days';

import { ACTIVITY_TYPES } from '../../../constants/common/statusTypes';

const Week = props => {

    const {
        brokerAvailabilities,
        actions,
        status
    } = props;

    const isDisabled =  status === ACTIVITY_TYPES.INACTIVE;

    const setToClosed = (index, d) => {
        const newArr = [ ...brokerAvailabilities ];
        newArr[index] = { day: d, fromTime: 'closed', toTime: 'closed' };
        actions.updateBrokerConnectDataWithoutSave({ ...props, brokerAvailabilities: newArr });
    };

    const updateHandler = (e, index, type) => {
        const obj = brokerAvailabilities[index];

        if(e.target.value === 'closed') {
            setToClosed(index, obj.day);
        } else {
            const newObj = { ...obj, [type]: e.target.value }; 
            const newArr = [...brokerAvailabilities];                   
            newArr[index] = newObj;
            actions.updateBrokerConnectDataWithoutSave({ ...props, brokerAvailabilities: newArr });
        }
    
    };

    const closedBtnHandler = (e, day, index ) => {
        const isChecked = e.target.checked;
        let dayObj = { 'day': day, fromTime: '08:00', toTime: '17:00' };
        if(isChecked) {
            dayObj = { 'day': day, fromTime: 'closed', toTime: 'closed' };
        }

        const newArr = [...brokerAvailabilities];
        newArr[index] = dayObj;
        actions.updateBrokerConnectDataWithoutSave({ ...props, brokerAvailabilities: newArr });
    };
  
   
    const setSameAsMondayHandler = () => {

        const { toTime, fromTime } = brokerAvailabilities[0];    
        const newArr = brokerAvailabilities.map( (dayObj, index)  => {
            return (index === 5 || index === 6) ? dayObj : { ...dayObj, 'toTime': toTime, 'fromTime': fromTime };
        });

        actions.updateBrokerConnectDataWithoutSave({ ...props, brokerAvailabilities: newArr });
    };

    return (
        <div className="grid-row">
            <div className="moblie:grid-col tablet:grid-col-10 desktop:grid-col-9">
                <fieldset className="grid-row week-container">
                    <legend>
                        <strong>
                            <FormattedMessage id='brokerconnect.availability.msg.pacific_time' />
                        </strong>
                    </legend>

                    <Days { ...props }  updateHandler={ updateHandler }  closedBtnHandler={ closedBtnHandler } />
                </fieldset>
            </div>
            <div className="moblie:grid-col tablet:grid-col-2 desktop:grid-col-3">
                <div className="controls-container weekday-container">
                    <div className="grid-row controls padding-105">
                        <div className="grid-col buttons-group">
                            <button className="usa-button gi-button gi-button__primary" onClick={  setSameAsMondayHandler } disabled={ isDisabled }>
                                <FormattedMessage id="brokerconnect.week.btn.weekday_hours" />
                            </button>
                            <p>
                                <FormattedMessage id="brokerconnect.week.msg.apply_monday_to_all" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        updateBrokerConnectDataWithoutSave
    }, dispatch)
});

export default connect(null, matchDispatchToProps)(Week);